export const ButtonActions = {
  DELETE: 'delete',
  EDIT: 'edit',
};
